import { AddShoppingCartOutlined } from "@mui/icons-material";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Rating,
  Typography,
} from "@mui/material";
import React from "react";
import "./ProductCard.css";

const ProductCard = ({ product, handleAddToCart }) => {
  return (
    <Card className="card">
      <CardMedia component="img" image={product.image} alt={product.name} height="200" />
      <CardContent>
        <Typography>{product.name}</Typography>
        <Typography variant="h6" >${product.cost}</Typography>
        <Rating value={product.rating} readOnly />
      </CardContent>
      <CardActions>
        <Button className="card-button" variant="contained" fullWidth startIcon={<AddShoppingCartOutlined />} onClick={()=>handleAddToCart(product._id, 1)} >ADD TO CART</Button>
      </CardActions>
    </Card>
  );
};

export default ProductCard;
